/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback, useEffect, useState} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {DownloadJob} from '@ion/core/src/types/entities';
import {IonSnackbar} from '@ion/dls/src/notifications/IonSnackbar';

// defines the Success Prop type definitions ...
export interface SuccessProps {
  result?: DownloadJob | null;
  loading?: boolean;
  label?: string;
}

/**
 * @Success
 *
 * The Success provides the UI for Cancelling an Job action.
 *
 * ```typescript
 *
 *    import {Success} from '@ion/ion-ctc-admin/src/jobs';
 *
 *    <Success label={label}
 *      result={result}
 *      loading={loading} />
 *
 * ```
 *
 * @param {DownloadJob}   result The Jov returned by the service after it has been deleted.
 * @param {boolean}       loading When true, indicates that the job is currently being
 *                        deleted.
 * @param {string}        label A reference to the label If the cancellation succes.
 */
export const Success = ({
  result,
  loading,
  label
}: SuccessProps) => {
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (result && !loading) {
      setShowSuccess(true);
    }
  }, [result, loading]);

  const close = useCallback(function() {
    setShowSuccess(false);
  }, []);

  if (showSuccess) {
    return (
      <>
        <IonSnackbar show={showSuccess}
          message={label}
          actionLabel={translate('common:editors.delete.ok')}
          onAction={close}
          onClose={close}
          autoHideDuration={3000} />
      </>
    );
  }
  return null;
};

export default Success;
